var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24412_6926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43242 14.086L5.73625 16.6849L3.19176 16.7388C2.43133 15.3283 2 13.7146 2 11.9998C2 10.3415 2.40328 8.77779 3.11812 7.40088H3.11867L5.38398 7.81619L6.37633 10.0679C6.16863 10.6734 6.05543 11.3234 6.05543 11.9998C6.05551 12.7338 6.18848 13.4372 6.43242 14.086Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8253 10.1318C21.9401 10.7368 22 11.3615 22 12C22 12.7159 21.9247 13.4143 21.7813 14.0879C21.2945 16.3802 20.0225 18.3818 18.2605 19.7983L18.2599 19.7978L15.4066 19.6522L15.0028 17.1313C16.172 16.4456 17.0858 15.3725 17.5671 14.0879H12.2198V10.1318H17.6451H21.8253Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2599 19.7979L18.2604 19.7985C16.5467 21.176 14.3698 22.0001 12 22.0001C8.19177 22.0001 4.8808 19.8716 3.19177 16.7392L6.43244 14.0864C7.27693 16.3403 9.45111 17.9447 12 17.9447C13.0956 17.9447 14.122 17.6485 15.0027 17.1315L18.2599 19.7979Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.383 4.30219L15.1434 6.95437C14.2319 6.38461 13.1544 6.05547 12 6.05547C9.39344 6.05547 7.17859 7.73348 6.37641 10.0681L3.11871 7.40109H3.11816C4.78246 4.1923 8.1352 2 12 2C14.4264 2 16.6511 2.8643 18.383 4.30219Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24412_6926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/ic_google.a7268071c24395ed3f1ba08d44067771.svg";
export { ForwardRef as ReactComponent };